import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export function provideVanillaTsTokens(registerFn: () => void): EnvironmentProviders {
  registerFn();
  return makeEnvironmentProviders([]);
}
